import {getEnviroment} from '../shared';

const coreBaseUrl = getEnviroment({
    prod: 'https://gateway.yooga.com.br/integration/',
    develop: 'https://alpha.core.yooga.com.br/',
    test: 'http://localhost:3000/', 
})

export const constants = {
    dom: {
        development: getEnviroment({
            prod: false,
            develop: true,
            test: true,
        })
    },
    integrations: {
        base_url: coreBaseUrl
    },
    
    viacep:{
        base_url: getEnviroment({
            prod: 'https://viacep.com.br/ws/',
            develop: 'https://viacep.com.br/ws/',
            test: 'https://viacep.com.br/ws/'
        })
    },
    cnpja:{
        base_url: getEnviroment({
            prod: 'https://api.cnpja.com/office/',
            develop: 'https://api.cnpja.com/office/',
            test: 'https://api.cnpja.com/office/',
        }),
        token: getEnviroment({
      prod: "eb74e1ab-953f-4de8-9106-73e5158a4932-783d925f-6f98-4329-a588-35c78520bfc4",
      develop:
        "eb74e1ab-953f-4de8-9106-73e5158a4932-783d925f-6f98-4329-a588-35c78520bfc4",
      test: "eb74e1ab-953f-4de8-9106-73e5158a4932-783d925f-6f98-4329-a588-35c78520bfc4",
    }),
  },

  minhareceita: {
    base_url: getEnviroment({
      prod: "https://minhareceita.org/",
      develop: "https://minhareceita.org/",
      test: "https://minhareceita.org/",
    }),
    },
    
    state: {
        client: {
            email: getEnviroment({
                prod: '', 
                develop: 'invalid@gmail.com',
                test: 'invalid@gmail.com',
            })
        },
    }
}

